import { render, staticRenderFns } from "./UiRadioGroup.vue?vue&type=template&id=34213130&scoped=true&"
import script from "./UiRadioGroup.vue?vue&type=script&lang=js&"
export * from "./UiRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./UiRadioGroup.vue?vue&type=style&index=0&id=34213130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34213130",
  null
  
)

export default component.exports